<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        แก้ไขบริษัทผู้ให้บริการ
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> จัดการบริษัทผู้ให้บริการ
          </a>
        </li>
        <li class="active">แก้ไขบริษัทผู้ให้บริการ</li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box">
              <div class="box-header">
                <!-- <h3 class="box-title">Hover Data Table</h3> -->
                <div class="wrapper_addtypegroup">
                  <el-form
                    size="mini"
                    :label-position="label_position"
                    label-width="150px"
                    :model="formEdit"
                    ref="ruleForm"
                    class="demo-ruleForm"
                  >
                    <div class="row">
                      <div class="col-xs-6">
                        <el-form size="mini">
                          <el-form-item label="ประเภทการให้บริการ">
                            <el-select v-model="formEdit.service_type">
                              <el-option label="โทรศัพท์เคลือนที่" value="mobile"></el-option>
                              <el-option label="อินเทอร์เน็ตความเร็วสูงประจำที่" value="broadband"></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="ชื่อบริษัท / ชื่อองค์กร / ชื่อผู้ให้บริการ">
                            <el-input placeholder="กรุณากรอกข้อมูล" v-model="formEdit.company_name"></el-input>
                          </el-form-item>
                          <el-form-item label="ชื่อแบรนด์ของผู้ให้บริการ">
                            <el-input placeholder="กรุณากรอกข้อมูล" v-model="formEdit.brand_name"></el-input>
                          </el-form-item>
                          <el-form-item label="โลโก้บริษัท">
                            <el-upload
                              class="avatar-uploader"
                              action="#"
                              :auto-upload="false"
                              :show-file-list="false"
                              :on-change="changePic"
                            >
                              <img v-if="formEdit.logo" :src="formEdit.logo" class="avatar" />
                              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                          </el-form-item>
                          <el-form-item label="โค้ดสีบริษัท (ใช้สำหรับรายงาน)">
                            <el-input
                              placeholder="กรุณากรอกข้อมูล"
                              v-model="formEdit.color"
                              type="color"
                              style="width:300px;"
                            ></el-input>
                          </el-form-item>
                        </el-form>
                      </div>
                    </div>
                    <div class="box-footer">
                      <el-button type="primary" @click="submitForm('ruleForm')">บันทึก</el-button>
                    </div>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import { mapState,mapActions } from "vuex";
export default {
  data() {
    return {
      label_position: "top",
      formEdit: {
        id: "",
        company_name:"",
        short_name:"",
        brand_name:"",
        service_type:"",
        logo:"",
        logo_path:"",
        file: null,
        color:"" 
      }
    };
  },
  computed: {
    ...mapState({
      prepare : store => store.ListOperator.prepare
    })
  },
  mounted() {
    if (this.prepare != null) {
      this.formEdit.id = this.prepare.info;
      this.formEdit.company_name = this.prepare.name;
      this.formEdit.short_name = this.prepare.short_name;
      this.formEdit.brand_name = this.prepare.brand_name;
      this.formEdit.service_type = this.prepare.type_tag;
      this.formEdit.logo = this.prepare.logo;
      this.formEdit.logo_path = this.prepare.logo_path;
      this.formEdit.color = this.prepare.color;
    } else {
      this.$router.push({ name: 'ListOperator' })
    }
    
  },
  methods: {
    ...mapActions({
      edit_operator: "ListOperator/edit_operator",
    }),
    changePic(file){
      this.formEdit.file = file.raw
      this.formEdit.logo = URL.createObjectURL(file.raw);
    },
    submitForm() {
      if(!this.formEdit.company_name){
        this.MessageBox("แจ้งเตือน", "กรุณาระบุชื่อบริษัท", "warning");      
      }else if(!this.formEdit.brand_name){
        this.MessageBox("แจ้งเตือน", "กรุณาระบุชื่อแบรนด์ของผู้ให้บริการ", "warning");      
      }else{
        let formData = new FormData();
        formData.append("typeFile","logo")
        formData.append("id", this.formEdit.id);
        formData.append('provider_type', this.formEdit.service_type);
        formData.append('name', this.formEdit.company_name);
        formData.append('short_name',this.formEdit.short_name);
        formData.append('brand_name', this.formEdit.brand_name);
        formData.append('color',this.formEdit.color)
        formData.append('file', this.formEdit.file);
        this.edit_operator(formData)
      }
    },
  }
};
</script>

